module.exports = __webpack_public_path__ + "static/media/img_contact_ways.aa465851.png";